/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_MeInputs */

const fr_household_me = /** @type {(inputs: Household_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moi`)
};

/**

* @param {Household_MeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_me = /** @type {((inputs?: Household_MeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_MeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_me(inputs)
});